import { useStore } from '@nanostores/react';
import { PendingDowngradeMenu } from './PendingDowngradeMenu';
import { RequestUpgradeButton } from './RequestUpgradeButton';
import { Button } from '~/components/ui/Button';
import { Switch } from '~/components/ui/Switch';
import { teamStore } from '~/lib/stores/team';
import { userStore } from '~/lib/stores/user';
import { type OrganizationData, type OrganizationMembership } from '~/types/organization';

interface SubscriptionCellProps {
  member: OrganizationMembership;
  organization: OrganizationData;
  isReadonlyView: boolean;
  isSelf: boolean;
  isOnboarding: boolean;
  refetchMembers: VoidFunction;
}

export const SubscriptionCell = ({
  organization,
  isReadonlyView,
  isSelf,
  isOnboarding,
  member,
  refetchMembers,
}: SubscriptionCellProps) => {
  const user = useStore(userStore.user);

  const handleSubscriptionChange = (member: OrganizationMembership, isUpgrade: boolean) => {
    teamStore.updateMembersSubscription([member.user.username], organization, isUpgrade);
  };

  if (member.downgraded) {
    return <PendingDowngradeMenu member={member} organization={organization} refetchMembers={refetchMembers} />;
  }

  if (isOnboarding) {
    return (
      <Switch
        size="sm"
        checked={!!member.withMembership}
        disabled={isReadonlyView}
        onCheckedChange={(value) => {
          handleSubscriptionChange(member, value);
        }}
      />
    );
  }

  if (member.withMembership) {
    return <div className="i-heroicons:check-circle-solid text-xl text-bolt-ds-brand" />;
  }

  if (!user?.featureFlags.teamManagement) {
    return null;
  }

  if (!member.withMembership && isReadonlyView && isSelf) {
    return <RequestUpgradeButton member={member} organization={organization} />;
  }

  if (!isReadonlyView) {
    return (
      <Button
        variant="link-color"
        color="success"
        onClick={() => {
          handleSubscriptionChange(member, true);
        }}
      >
        Upgrade
      </Button>
    );
  }

  return null;
};
